export default __webpack_public_path__ + "static/media/argus.298865c7.jpg";